import { DrawerFAQsType } from '../../organisms/DrawerFAQsList/DrawerFAQsList.types'
import {
  HELP_BEST_PRACTICES_TIPS_TRICKS_URL,
  HELP_PRINTER_NEAR_YOU_URL
} from '@dtx-company/true-common/src/constants/help'

export const TEMPLATE_FAQS_LIST: DrawerFAQsType[] = [
  {
    title: 'How do I put my code in a template?',
    link: 'https://vimeo.com/685625746',
    video: true
  },
  {
    title: 'Locating a printer near you',
    link: HELP_PRINTER_NEAR_YOU_URL
  },
  {
    title: 'Best printing practices (tips, tricks, and need-to-knows)',
    link: HELP_BEST_PRACTICES_TIPS_TRICKS_URL
  },
  {
    title: 'How should I display my code?',
    link: 'https://vimeo.com/711706641 ',
    video: true
  }
]
